import(/* webpackMode: "eager" */ "/codebuild/output/src391911660/src/CVCircuit/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src391911660/src/CVCircuit/frontend/components/AffiliateAutoApply.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/codebuild/output/src391911660/src/CVCircuit/frontend/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src391911660/src/CVCircuit/frontend/components/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StripeProvider"] */ "/codebuild/output/src391911660/src/CVCircuit/frontend/components/StripeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src391911660/src/CVCircuit/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src391911660/src/CVCircuit/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
